import { Box } from "@mui/material";
import { Modal } from "react-bootstrap"; // TODO: Replace with MUI

// PDF now served from public directory

import stepTwoImage from "images/evaluation-process/step-two.png";

export default function StepTwoModal({ show, setShowStepTwoModal }) {
  const handleClose = () => {
    setShowStepTwoModal(false);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header className="border-0 pb-0" closeButton></Modal.Header>
      <Modal.Body className="px-5 pt-0">
        <div className="d-flex justify-content-center">
          <img
            src={stepTwoImage}
            alt="step two image"
            className="w-auto"
            height="120px"
          />
        </div>

        <h3 className="text-uppercase text-center fw-bold mb-3 text-primary">
          Step 2
        </h3>

        <h5 className="fw-bold">
          <a href="/publications/CICO.pdf">Check-In Process</a>
        </h5>

        <Box
          component="ul"
          className="mt-4"
          sx={{
            pl: 1,
            "& li": { my: "8px" },
            "& li h5": { mt: 3 },
          }}
        >
          <li>
            <h5 className="fw-bold">
              CCTL completes the Check-in form and includes the Check-in package
              for submittal to the Vendor. Once the Vendor signs off on the
              Evaluation it is Proposed to NIAP
            </h5>
            <ul>
              <li>
                Include: Claimed Protection Profile(s), Draft Security Target,
                Entropy Assessment Report (EAR) (if required), Estimated 90-day
                Timeline
                <ul>
                  <li>
                    If an SBOM is required for the evaluation, this must be
                    submitted to the NIAP SBOM group via a separate process.
                    CCTLs should refer to the guidance issued in Labgram #117
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            <h5 className="fw-bold">Evaluation "Checked In" with NIAP</h5>
            <ul>
              <li>NIAP Accepts the evaluation proposal</li>
              <li>Validator Resources are assigned</li>
              <li>
                Deliverables Reviewed/PP Conformance Claims Analyzed
                <ul>
                  <li>EAR Review conducted (if required)</li>
                </ul>
              </li>
              <li>
                Check-in Meeting conducted and project assigned a Kickoff Date
                <ul>
                  <li>Formalized via eCheck-in or Telecon</li>
                  <li>Sync sessions may be required at time of Check-in</li>
                  <li>Product placed on the In-Evaluation List</li>
                </ul>
              </li>
            </ul>
          </li>
        </Box>

        <h5 className="fw-bold my-4">
          Timeline: Est. 3 weeks (4 weeks if EAR is required)
        </h5>
      </Modal.Body>
    </Modal>
  );
}
